import React, { useEffect, useState } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import Layout from '../components/Layout/Layout';
import PrivateRoute from './privateRoute';
import { appRoutes } from './routes';

const NavigationRoutes = () => {
  return (
    <BrowserRouter>
      <Switch>
        {/* {validRoute? */}
        <Layout>
          {appRoutes.map((route, index) => {
            const isProtected = route.protected;
            return isProtected ? (
              <PrivateRoute
                exact
                path={route.path}
                component={route.component}
                key={'route_' + index}
              />
            ) : (
              <Route key={'route_' + index} exact path={route.path} component={route.component} />
            );
          })}
        </Layout>
        {/* // :<Redirect to={{ pathname: '/' }} />
    // } */}
      </Switch>
    </BrowserRouter>

    // <Route path='*' element={<p>Page not found</p>} />
  );
};

export default NavigationRoutes;
